import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LOCALE from 'constants/locale';

import { en } from 'translations';

i18n.use(initReactI18next).init({
  lng: 'en',
  resources: {
    en: {
      translation: en,
    },
  },
  keySeparator: false,
  nsSeparator: false,
  fallbackLng: LOCALE.EN,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
